import React from "react";

interface IClassroomToolsContext {
	openRuleModal: (isEditing: boolean, url: string, signature: string, username: string) => void;
}

export const ClassroomToolsContext = React.createContext<IClassroomToolsContext>({
	openRuleModal: () => {},
});
